module.exports = __webpack_public_path__ + "img/logos-clientes.c47992f6.png";